<template>
    <div class="audience-geography campaign-step">
        <div class="step-header">
            <div class="step-icon">
                <img src="/images/users.svg" alt="audience and geography" />
            </div>
            <h2>{{ $t('messages.audience_geography') }}</h2>
        </div>

        <div class="settings-content">
            <!-- География показов -->
            <GeographySelector :geography="localData.geography" :geographies="geographies" @update="updateGeography" />

            <!-- Сегменты аудитории -->
            <AudienceSegments :audiences="audiences" :selected="localData.audiences"
                @update:audiences="updateSelectedAudiences" />

        </div>
    </div>
</template>

<script>
import GeographySelector from './AudienceGeography/GeographySelector.vue';
import AudienceSegments from './AudienceGeography/AudienceSegments.vue';

export default {
    name: "AudienceGeography",
    components: {
        GeographySelector,
        AudienceSegments
    },
    props: {
        // adGroup object when editing (preferred, same pattern as DeviceTargeting)
        campaign: {
            type: Object,
            default: null
        },
        // fallback: initial data prepared by parent (audienceSegments + geography)
        initialData: {
            type: Object,
            default: null
        },
        geographies: {
            type: Array,
            default: () => []
        },
        audiences: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            localData: {
                geography: [],
                // audiences: flat array of selected audience ids
                audiences: []
            }
        };
    },
    mounted() {
        this.initializeData();
    },
    watch: {
        // prefer campaign prop (edit mode) similar to DeviceTargeting
        campaign: {
            handler(val) {
                if (val) this.initializeData();
            },
            deep: true,
            immediate: true
        },
        // fallback to initialData when campaign not present
        initialData: {
            handler(val) {
                if (!this.campaign && val) this.initializeData();
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        initializeData() {
            // prefer campaign (adGroup) when present - mirrors operatingSystems approach
            const src = this.campaign || this.initialData || {};
            if (src) {
                // geographies
                if (Array.isArray(src.geographies)) this.localData.geography = src.geographies.map(g => (g && g.id) ? g.id : Number(g)).filter(Boolean);
                else if (Array.isArray(src.geography)) this.localData.geography = src.geography.map(Number).filter(Boolean);

                // Normalize to flat audiences array only (no grouped legacy structures)
                if (Array.isArray(src.audiences) && src.audiences.length) {
                    this.localData.audiences = src.audiences.map(a => (a && a.id) ? Number(a.id) : Number(a)).filter(Boolean);
                } else if (Array.isArray(src.audience_ids) && src.audience_ids.length) {
                    this.localData.audiences = src.audience_ids.map(Number).filter(Boolean);
                } else {
                    this.localData.audiences = [];
                }
            }
        },

        updateGeography(geography) {
            this.localData.geography = geography;
            this.updateData();
        },

        // receives flat array of selected audience ids from AudienceSegments component
        updateSelectedAudiences(audIds) {
            this.localData.audiences = Array.isArray(audIds) ? audIds.map(Number).filter(Boolean) : [];
            this.updateData();
        },

        updateData() {
            // Преобразуем данные для отправки
            const dataToEmit = {
                // География как массив ID
                geography: this.localData.geography,
                // Аудитории — единый flat массив id
                audiences: this.localData.audiences
            };
            this.$emit('update', dataToEmit);
        },

        validateData() {
            const errors = [];

            if (!this.localData.geography || this.localData.geography.length === 0) {
                errors.push('Необходимо выбрать хотя бы одну географию');
            }

            return errors;
        }
    }
}
</script>

<style lang="scss" scoped>
.audience-geography {
    max-width: 1000px;
}
</style>
